import { cycleCountIdFormat } from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const completeCycleCount = unaryRpc({
  name: "completeCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  /** Completing always applies the count; variance is reported, not gated. */
  output: z.object({ productsOverVariance: z.int() }),
});
